import { VIDEO_LIST_ACTION } from 'core/constants/Actions'
import { Action } from 'core/models/ActionTypes'
import { WebVideo } from 'core/models/WebVideo'

const intialState: { videos: WebVideo[], count: number, currentPage: number, isLoading: boolean } = {
  videos: [],
  isLoading: false,
  count: 0,
  currentPage: 0
}

interface ActionType extends Action {
  payload: {
    videos: WebVideo[];
    count: number;
    currentPage: number;
  }
}

export default function videoListReducer(state = intialState, action: ActionType) {

  switch (action.type) {
    case VIDEO_LIST_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case VIDEO_LIST_ACTION.SUCCESS:
      const { videos, count, currentPage } = action.payload;
      return { ...state, videos, count, currentPage, isLoading: false }

    case VIDEO_LIST_ACTION.FAILURE:
      return { ...state, ...intialState }

    default:
      return state
  }
}
